import { createFileRoute } from "@tanstack/react-router";

import Login from "../pages/Login";

export const Route = createFileRoute("/_shell/login")({
  validateSearch: (search): { return_to?: string } =>
    typeof search.return_to === "string" ? { return_to: search.return_to } : {},
  component: LoginRoute,
});

function LoginRoute() {
  const { return_to: returnTo } = Route.useSearch();
  return <Login returnTo={returnTo} />;
}
